'use strict';

$('.js-event-search').on('click', function () {
  const $this = $(this);
  const data = $this.data('event') || $this.parents('[data-event]').data('event');
  blz.eventTracking.search(data);
});

$('body').on('click', '.js-event-product-click', function () {
  const $this = $(this);
  const data = $this.data('event') || $this.parents('[data-event]').data('event');
  blz.eventTracking.productClick(data);
});
